export const Home = () => {
  return (
    <div>
      <h1>Home</h1>
    </div>
  );
};
